import { gql } from '@apollo/client';
import OnBoardingFragment from '@/entities/study/api/fragments/onBoardingFragment';
import { PatientFragment } from '@/shared/api';

const STUDY_PATIENT_INFO_QUERY = gql`
  query study($id: ID!) {
    study(id: $id) {
      id
      onboarding {
        ...OnBoardingFragment
      }
      info {
        patient {
          ...PatientFragment
        }
        diagnosis {
          primary
          second
          physiciansNote
          patientMedications
        }
        insurance {
          type
          provider
          preAuth
        }
        interprettingPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        referringPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
      }
      device {
        id
        deviceId
        model
      }
      isAFibDetected
      hasAFibCode
    }
  }

  ${OnBoardingFragment}
  ${PatientFragment}
`;

export default STUDY_PATIENT_INFO_QUERY;
